import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCalendarDay } from "@fortawesome/free-solid-svg-icons"

export const CalendarDay = (props) => {
  return <FontAwesomeIcon faIcon={faCalendarDay} {...props} />
}
